import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Solutions from "@/pages/Solutions";
import HowItWorks from "@/pages/HowItWorks";
import About from "@/pages/About";
import RequestQuote from "@/pages/RequestQuote";
import AdminLeads from "@/pages/AdminLeads";
import SeoChecklist from "@/pages/SeoChecklist";
import AdminAccount from "@/pages/AdminAccount";
import SeoPlan from "@/pages/SeoPlan";
import BrandAssets from "@/pages/BrandAssets";
import Locations from "@/pages/Locations";
import RegionPage from "@/pages/RegionPage";
import LegalPage from "@/pages/LegalPage";
import { LEGAL_PAGES } from "@/lib/legal";

// Shared by the browser app and the build-time prerenderer (scripts/prerender.mjs).
export const AppRoutes = () => (
  <div className="App">
    <Routes>
      <Route path="/" element={<Layout><Home /></Layout>} />
      <Route path="/services" element={<Layout><Services /></Layout>} />
      <Route path="/solutions" element={<Layout><Solutions /></Layout>} />
      <Route path="/how-it-works" element={<Layout><HowItWorks /></Layout>} />
      <Route path="/about" element={<Layout><About /></Layout>} />
      <Route path="/request-a-quote" element={<Layout><RequestQuote /></Layout>} />
      <Route path="/locations" element={<Layout><Locations /></Layout>} />
      <Route path="/lake-mapping/:slug" element={<Layout><RegionPage /></Layout>} />
      {Object.keys(LEGAL_PAGES).map((slug) => (
        <Route key={slug} path={`/${slug}`} element={<Layout><LegalPage slug={slug} /></Layout>} />
      ))}
      <Route path="/admin" element={<Layout><AdminLeads /></Layout>} />
      <Route path="/admin/seo-checklist" element={<Layout><SeoChecklist /></Layout>} />
      <Route path="/admin/account" element={<Layout><AdminAccount /></Layout>} />
      <Route path="/admin/seo-plan" element={<Layout><SeoPlan /></Layout>} />
      <Route path="/admin/brand" element={<Layout><BrandAssets /></Layout>} />
    </Routes>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
